const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Quiz Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze the resource defined to manage Analyze
 * @argument {Quizzes} Quizzes the resource defined to manage Quizzes
 * @argument {UserTracks} UserTracks the resource defined to manage UserTracks
 * @argument {Scores} Scores the resource defined to manage Scores
 */
app.directive('quizViewer', ['Application', 'Authorization', 'Analyze', 'Quizzes', 'Scores', '$translate', function (Application, Authorization, Analyze, Quizzes, Scores, $translate) {
  return {
    restrict: 'E',
    scope: {
      quizId: '=',
      trackId: '=',
      userTrack: '=',
      nextForQuiz: '&',
      onComplete: '&'
    },
    template: require('../../templates/directives/quiz-viewer.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      self.loading = true;

      self.tracking = new Application.Tracking(Analyze, moment, 'quiz', $scope.trackId || null);
      if (self.inTrack && !$scope.trackId) {
        var trackWatch = $scope.$watch('trackId', function(newVal) {
          if (newVal) {
            self.tracking.setTrackId($scope.trackId);
            trackWatch();
          }
        });
      }

      var sortByProp = function(arr, prop) {
        arr.sort(function(a, b) {
          if (a[prop] > b[prop]) {
            return 1;
          }
          if (a[prop] < b[prop]) {
            return -1;
          }
          return 0;
        });
      };

      self.trackHome = function() {
        Application.navigation.goTo('/view/tracks/' + $scope.trackId);
      };

      self.allowNextSet = function() {
        if (!self.sections || self.currentSection === undefined || self.currentSection === null) {
          return;
        }
        for (var i = 0; i < self.sections[self.currentSection].length; i++) {
          var item = self.sections[self.currentSection][i];
          if (!self.userAnswers[item.number]) {
            return false;
          }
        }
        return true;
      };

      self.makeProgress = function() {
        if (!self.sections) {
          return;
        }

        self.userAnswered = 0;
        for (var key in self.userAnswers) {
          if (self.userAnswers[key] !== null) {
            self.userAnswered++;
          }
        }
        self.percent = Math.round(self.userAnswered / self.totalQuestions * 100);
        return {
          'width': self.percent + '%'
        };
      };

      // This function should be called after every submission and when an item is completed
      self.setPermission = function() {
        self.loading = false;
        // Check if the user has taken this before
          // If not, they are allowed to take it
        // Check if the user allows multiple retakes
          // If the user has not met max attempts - allow them to take it
        // Dont allow user to take it
        var retake = parseInt(self.quiz.retake) || 0;
        if (!self.scores.length) {
          return;
        }
        if (retake + 1 > self.scores.length) {
          return;
        }
        if (self.checkIfTaken($scope.userTrack)) {
          self.passed = true;
          return;
        }

        self.failed = true;
        self.allowRetake = false;
      };

      self.retakeQuiz = function() {
        self.setInitials();
        self.setPermission();
      };

      self.checkIfTaken = function(uTrack) {
        for (var i = 0; i < uTrack.completed_quizzes.length; i++) {
          if (uTrack.completed_quizzes[i].toString() === $scope.quizId.toString()) {
            return true;
          }
        }
        return false;
      };

      self.makeSections = function() {
        var sectionCount = 0;
        sortByProp(self.quiz.questions, 'number');

        for (var i = 0; i < self.quiz.questions.length; i++) {
          if (!self.sections[sectionCount]) {
            self.sections[sectionCount] = [];
          }
          if (self.sections[sectionCount].length === 4) {
            sectionCount++;
            self.sections[sectionCount] = [];
          }
          self.sections[sectionCount].push(self.quiz.questions[i]);
          self.totalQuestions++;
        }
      };

      self.navSection = function(direction) {
        if (direction && self.sections[self.currentSection + 1]){
          self.currentSection++;
        }
        if (!direction && self.sections[self.currentSection - 1]){
          self.currentSection--;
        }
      };

      self.quizCompleted = function() {
        $scope.onComplete();
      };

      self.submitQuiz = function() {
        self.submitted = true;
        var scoreList = [];

        for (var key in self.userAnswers) {
          if (!self.userAnswers[key]) {
            $translate(['quizviewer.complete_all'], { keyval: key }).then(function (translations) {
              Application.messaging.addMessage({type: error, duration: 5, text: translations['quizviewer.complete_all']});
            });
            console.log('Must complete all questions. Question ' + key + 'has not been completed.');
            return;
          }
          scoreList.push({
            questionNumber: parseInt(key),
            letter: self.userAnswers[key]
          });
        }

        Scores.create({
          user: self.user._id,
          quiz: $scope.quizId
        }, {
          answers: scoreList
        }, function(data) {
          if (!self.scores) {
            self.scores = [];
          }
          self.scores.push(data);

          if (data.percentage >= self.quiz.min_pass) {
            self.quizCompleted();
            self.submitted = false;
            self.passed = true;
            return;
          }

          self.submitted = false;
          self.failed = true;
          self.setPermission();
        }, function(err) {
          self.submitted = false;
          console.log('Error occured getting scoring quiz ', err);
          Application.notifications.setError('Unable to score the quiz.');
        });
      };

      var initialSets = 0;
      self.setInitials = function() {
        self.failed = false;
        self.allowRetake = true;
        self.passed = false;
        self.currentSection = 0;
        self.percent = 0;
        self.userAnswered = 0;
        self.userAnswers = {};
        if (initialSets) {
          self.clearAnswers = !self.clearAnswers;
        }
        initialSets++;
      };

      self.initialize = function () {
        initialSets = 0;
        self.loading = true;
        self.scores = null;
        self.quiz = null;
        self.sections = [];
        self.totalQuestions = 0;
        self.setInitials();

        if (!$scope.quizId || !$scope.trackId) {
          return;
        }

        if (self.checkIfTaken($scope.userTrack)) {
          // Show success message if the user track shows the quiz as taken
          self.passed = true;
          self.loading = false;
        }

        Quizzes.get({
          subresource: $scope.quizId,
          fields: 'title,description,questions,questions.answers,min_pass,retake,show_results'
        }, function (data) {
          self.quiz = data;
          self.tracking.start(self.quiz);
          self.makeSections();
          if (self.scores) {
            self.setPermission();
          }
        }, function (error) {
          console.log('Error occured getting quiz ', $scope.quizId, error);
          Application.notifications.setError('Unable to get quiz.');
        });

        Scores.find({
          user: self.user._id,
          quiz: $scope.quizId
        }, function (data) {
          self.scores = data;
          if (self.quiz) {
            self.setPermission();
          }
        }, function (error) {
          console.log('Error occured getting scores ', error);
          Application.notifications.setError('Unable to get scores.');
        });
      };

      $scope.$on('$destroy', function() {
        self.tracking.end();
      });

      $scope.$watch('quizId', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.initialize();
      });

      $scope.$watch('trackId', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.initialize();
      });

      if ($scope.userTrack && $scope.userTrack._id) {
        self.initialize();
        return;
      }

      // Only perform actions below this when the usertrack has not yet been supplied
      var watchUserTrack = $scope.$watch('userTrack', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.initialize();
        watchUserTrack();
      }, true);

      // If the request for a user track isn't filled after 5 seconds, send the user to the track home 
      setTimeout(function() {
        if (!$scope.userTrack) {
          // There must be a user track associated with a track in order to take a quiz
          $translate(['quizviewer.click_to_start']).then(function (translations) {
            Application.messaging.addMessage({type: '', text: translations['quizviewer.click_to_start'], duration: 5});
          });
          Application.navigation.goTo('/view/tracks/' + $scope.trackId);
        }
      }, 5000);
    }],
    controllerAs: 'quizViewer'
  };
}]);
